import { render } from "./NotifyBase.vue?vue&type=template&id=21bfc65c&scoped=true"
import script from "./NotifyBase.vue?vue&type=script&lang=js"
export * from "./NotifyBase.vue?vue&type=script&lang=js"

import "./NotifyBase.vue?vue&type=style&index=0&id=21bfc65c&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bfc65c"]])

export default __exports__